export default __webpack_public_path__ + "static/media/fl-division.64be6b24.jpg";